module.exports = __webpack_public_path__ + "img/Uncleat Stamp.23cadb2f.png";